module.exports = __webpack_public_path__ + "img/IT0002103209174.42f78e61.png";